module.exports = __webpack_public_path__ + "static/quiz-app-mobile-plp-8799d14f263855845b926bb4fcbc7ae2.png";